import { Component } from '@angular/core';
import { UserContext } from './shared/services/user-context.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  title = 'Horizon';
  
  constructor(private userContext: UserContext) {}

  ngOnInit() {
    if (!this.userContext.isLoggedIn())
      this.userContext.login();
  }
}
